import ModalCustom from "./modal-template-default";
import useFormat from "../../hooks/utils/useFormat";
import Button from "../Button";
import Results from "../Results";

export default function ModalLogs(props) {
  const { show, onHide, slip } = props;
  const { formatReal, formatLogs } = useFormat();

  return (
    <ModalCustom size="md" show={show} onHide={onHide}>
      <ModalCustom.Header>
        <h2 className="page-title">Pagamento {slip?.id}</h2>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <Results
          rows={[
            {
              label: "Valor Inicial",
              value: formatReal(slip?.value_raw || 0),
              type: "dark",
            },
            ...(slip?.tax > 0
              ? [
                  {
                    label: "Taxa",
                    value: `${formatReal(slip?.tax || 0)} ${
                      !!slip?.tax_description ? `(${slip?.tax_description})` : ""
                    }`,
                  },
                ]
              : []),
            ...(slip.discount > 0
              ? [
                  {
                    label: "Desconto (Negociação)",
                    value: (
                      <div className="text-end">
                        <span className="d-block">{formatReal(slip?.discount || 0)} </span>
                        <span className="small-label">{slip?.discount_description || ""}</span>
                      </div>
                    ),
                  },
                ]
              : []),
            ...(slip?.value_juros > 0
              ? [
                  {
                    label: "Multa & Juros",
                    value: `+ ${formatReal(slip?.value_juros || 0)}`,
                  },
                ]
              : []),
            {
              label: <b>Total</b>,
              value: <b>{formatReal((slip?.value || 0) + (slip?.value_juros || 0))}</b>,
              type: "dark",
            },
            ...(slip.value_paid > 0
              ? [
                  {
                    label: "Valor Pago",
                    value: formatReal(slip?.value_paid || 0),
                  },
                ]
              : []),
          ]}
        />
        {!!slip?.description && (
          <>
            <div className="divisor mt-2 mb-2"></div>
            <p className="m-0 ">
              <b>Descrição:</b>
            </p>
            <p className="m-0">{slip?.description}</p>
          </>
        )}
        {slip?.logs?.length > 0 && (
          <>
            <div className="divisor mt-2 mb-2"></div>
            <p>
              <b>Registros:</b>
            </p>
            <div style={{ fontSize: ".8em" }}>
              {formatLogs({
                logs: slip?.logs || [],
                type: "payments",
              })}
            </div>
          </>
        )}
        {slip?.logs?.length > 9 && (
          <p className="small-label m-0 mt-2">
            Por enquanto, é disponibilizado apenas as 10 últimas atualizações. Caso deseje uma consulta mais
            aprofundada, entre em contato com a nossa equipe.
          </p>
        )}
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button onClick={onHide} color="primary_ghost">
          Fechar
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
}
